import { hasCapability, type User } from "../base";

export const finalInspection = {
  read: (user: User) => hasCapability(user, "finalInspection.read"),
};
